import { capitalDesignTokens } from "@opengov/capital-design-tokens";
const MuiDivider = {
  defaultProps: {},
  styleOverrides: {
    root: ({ theme }) => ({
      borderColor: theme.palette.divider,
      "&.MuiDivider-withChildren": {
        textTransform: "uppercase",
        fontSize: capitalDesignTokens.foundations.typography.fontSize.bodyXSmall,
        lineHeight: theme.spacing(3),
        fontWeight: capitalDesignTokens.foundations.typography.fontWeight.medium,
        color: theme.palette.text.primary,
        "&::before, &::after": {
          borderColor: theme.palette.divider
        },
        ".MuiDivider-wrapper": {
          padding: theme.spacing(0, 3),
          ".MuiSvgIcon-root": {
            fontSize: capitalDesignTokens.foundations.typography.fontSize.bodyDefault,
            verticalAlign: "text-top"
          },
          "> :not(:first-of-type)": {
            marginLeft: theme.spacing(2)
          }
        }
      }
    })
  }
};
export {
  MuiDivider
};
//# sourceMappingURL=MuiDivider.js.map
